import type { IsettingRateData } from '../../../types/SettingRateData';
import { useDeviceType } from '../../../hooks/useDeviceType';
import { Star } from './Star';
import { Text as Paragraph } from 'components/Typography';
import type { IRatingMsg } from 'components/Rating/types';

export interface IStarSpans extends Pick<IsettingRateData, 'isRatingGiven' | 'ratingGiven'> {
  value: number;
  handleClick: (value: number) => void;
  ratingMsg: IRatingMsg;
  setDynamicValue: (value: number) => void;
  dynamicValue: number;
  Rating: boolean;
}

export const StarSpans = ({
  value,
  isRatingGiven,
  ratingGiven,
  handleClick,
  ratingMsg,
  setDynamicValue,
  dynamicValue,
  Rating,
}: IStarSpans) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { isMobile } = useDeviceType();

  const handleMouseEnter = (newValue: number) => {
    if (!Rating) {
      setDynamicValue(newValue);
    }
  };

  const handleMouseLeave = () => {
    if (!Rating) {
      setDynamicValue(value);
    }
  };

  const starSpans = [];
  const max = 5;
  for (let v = 1; v <= max; v += 1) {
    starSpans.push(
      <Star
        key={v}
        isFilled={isRatingGiven ? v <= ratingGiven : v <= dynamicValue}
        value={v}
        handleHover={handleMouseEnter}
        handleHoverLeave={handleMouseLeave}
        handleClick={handleClick}
      />,
    );
  }
  const starSpansMobile = [];
  for (let v = 1; v <= max; v += 1) {
    starSpansMobile.push(
      <Star
        key={v}
        isFilled={isRatingGiven ? v <= ratingGiven : v <= dynamicValue}
        value={v}
        handleHover={handleMouseEnter}
        handleHoverLeave={handleMouseLeave}
        handleClick={handleClick}
      />,
    );
  }

  return (
    <>
      <div className="starSpans mb-2.5 hidden md:inline-block h-[3.75rem]">{starSpans}</div>
      {isMobile && starSpansMobile}
      <Paragraph
        className={
          dynamicValue !== 0 || isRatingGiven
            ? 'text-base uppercase mb-[1.375rem] text-gray-dark'
            : isMobile
              ? 'uppercase mb-0 mt-2.5'
              : 'text-base uppercase mb-[1.375rem]  text-gray-dark'
        }
        tag="div"
        type="lead"
        onMouseLeave={handleMouseLeave}
      >
        {ratingMsg?.message[isRatingGiven ? ratingGiven - 1 : dynamicValue - 1]}
      </Paragraph>
    </>
  );
};
